import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import useSendToAccounting from "./useSendToAccounting";
import usePrepareSendToAccounting from "./usePrepareSendToAccounting";
import { SendToAccountingActionContext } from "./SendToAccountingActionContext";

function useSendToAccountingAction(indexFunction: any): any {
  const prepareSendToAccounting = usePrepareSendToAccounting();
  const prepareSendToAccountingFunction = () => prepareSendToAccounting();

  const onSuccessSendToAccounting = () => {
    setShowModal(false);
    indexFunction();
  };

  const sendToAccounting = useSendToAccounting();
  const sendToAccountingFunction = () => sendToAccounting(onSuccessSendToAccounting);

  const contextInstance = useContext(SendToAccountingActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "send_to_accounting",
    onSubmit: () => sendToAccountingFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t("are_you_sure_you_want_to_send_to_accounting?")}
    </CrudModuleFactoryModal>
  );

  return {
    prepareSendToAccountingFunction,
    actionTemplate,
  };
}

export default useSendToAccountingAction;
